import React from 'react';
import { CheckIcon, LockKeyholeIcon } from 'lucide-react';
import { salesPageData, checkoutHref } from '../data/salesPageData';
import { CTAButton } from './ui/CTAButton';
const CONTENT = ['+500 planos y proyectos.', '8 Bonos Especiales.', 'Melamina.', 'Industrial.', 'Cocinas.', 'Proyectos de alto valor.', 'Calculadora del Carpintero.', 'Carpintería Desde Cero.', 'Acceso ilimitado.', 'Garantía 7 días.'];
export function FinalCTASection() {
  return <section className="relative overflow-hidden border-t border-[#D89A3D]/25 bg-[#181512]" aria-labelledby="final-cta-title" data-id="element-73" data-mp="2zbe54pk1ucn4">
      <div className="absolute left-1/2 top-1/4 h-[520px] w-[880px] -translate-x-1/2 rounded-full bg-[#FF7A00]/12 blur-[160px]" aria-hidden="true" data-id="element-74" data-mp="39boh66ucle0p" />
      <div className="wood-grain absolute bottom-0 left-0 h-20 w-full opacity-40" aria-hidden="true" data-id="element-75" data-mp="3e36iiw0a9gm7" />

      <div className="relative mx-auto grid max-w-content items-center gap-10 px-4 py-16 md:px-8 md:py-24 lg:grid-cols-[46%_1fr]" data-id="element-76" data-mp="2gmhkzeid90im">
        <div className="relative mx-auto w-full max-w-[520px]" data-id="element-77" data-mp="2ljr98qu0r64v">
          <div className="absolute inset-8 rounded-full bg-[#FF7A00]/16 blur-[90px]" aria-hidden="true" data-id="element-78" data-mp="26uhhjkri2bpa" />
          <img src={salesPageData.mainMockup} alt="Mockup de La Bóveda del Carpintero con el libro principal y las fichas de categorías de proyectos" className="relative w-full [filter:drop-shadow(0_0_6px_rgba(255,122,0,0.75))_drop-shadow(0_0_22px_rgba(255,122,0,0.5))_drop-shadow(0_0_55px_rgba(216,154,61,0.3))_drop-shadow(0_26px_40px_rgba(0,0,0,0.65))]" loading="lazy" width={1080} height={1080} data-id="element-79" data-mp="21wpqesyoitm5" />
        </div>

        <div className="text-center lg:text-left" data-id="element-80" data-mp="1j7j5r0ebrrxp">
          <p className="font-display text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#D89A3D]" data-id="element-81" data-mp="1e5k1zpeoat08">
            La Bóveda del Carpintero™
          </p>
          <p className="mt-2 text-sm text-[#EFEDE8]/60" data-id="element-82" data-mp="199mr3ym6ieuu">{salesPageData.tagline}</p>

          <h2 id="final-cta-title" className="title-glow reveal mt-5 font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#F8F3EA] sm:text-5xl" data-id="element-83" data-mp="38ia42uf738ip">
            Tu próximo proyecto
            <span className="accent-glow block text-[#FF7A00]" data-id="element-84" data-mp="11u16ysc34gep">ya está adentro.</span>
          </h2>

          <ul className="mx-auto mt-7 grid max-w-md gap-2 text-left sm:grid-cols-2 lg:mx-0 lg:max-w-none" data-id="element-85" data-mp="16onh6s6fk2x7">
            {CONTENT.map(item => <li key={item} className="flex items-start gap-2 text-sm text-[#EFEDE8]/85" data-id="element-86" data-mp="wwhpzko05pj2">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#FF7A00]" aria-hidden="true" data-id="element-87" data-mp="1kmva8p0cik33" />
                {item}
              </li>)}
          </ul>

          <div className="premium-glow mt-8 rounded-2xl border border-[#FF7A00]/50 bg-[#111111] p-6 text-center sm:p-8" data-id="element-88" data-mp="1pkx3g2rhjzsa">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#EFEDE8]/50" data-id="element-89" data-mp="1bo9sux6m1b3w">
              Valor referencial
            </p>
            <p className="font-numeric text-2xl font-bold text-[#EFEDE8]/55 line-through" data-id="element-90" data-mp="5p7kgdljle4">
              {salesPageData.referenceValue} {salesPageData.currency}
            </p>
            <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#D89A3D]" data-id="element-91" data-mp="3stpbtpylu3al">
              Precio promocional
            </p>
            <p className="accent-glow font-numeric text-5xl font-bold leading-none text-[#FF7A00] sm:text-6xl" data-id="element-92" data-mp="3nuvxjvbhu89d">
              {salesPageData.promotionalPrice}
            </p>
            <p className="mt-2 font-display text-xs font-extrabold uppercase tracking-[0.22em] text-[#F8F3EA]" data-id="element-93" data-mp="1oywqv1ufd5i">
              {salesPageData.currency} · Pago único
            </p>

            <div className="mt-7" data-id="element-94" data-mp="355fim2z2ad9f">
              <CTAButton href={checkoutHref()} external size="large" fullWidth data-id="element-95" data-mp="3567gjkg4sn2v">
                <LockKeyholeIcon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="3julog9sen1qa" />
                Quiero acceder ahora
              </CTAButton>
              <p className="mt-3 text-[11px] leading-relaxed text-[#EFEDE8]/55" data-id="element-97" data-mp="3f0qzorxxzwkc">
                Pago seguro · Acceso digital · Sin mensualidades · Garantía 7 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}